import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from './layouts/DashboardLayout';
import MainLayout from './layouts/MainLayout';
import LoginView from './views/auth/LoginView';
import NotFoundView from './views/errors/NotFoundView';
import LprEventListView from "./views/LprEvent/List";
import ParkingZoneListView from "./views/ParkingZone/List";
import CameraListView from "./views/Camera/List";
import CameraSetListView from "./views/CameraSet/List";
import ParkingEventListView from "./views/ParkingEvent/List";
import ParkingZoneFormView from "./views/ParkingZone/Form";
import CameraFormView from "./views/Camera/Form";
import CameraSetFormView from "./views/CameraSet/Form";
import AuditLogListView from "./views/AuditLog/List";
import UserListView from "./views/User/List";
import StatisticsDashboard from "./views/Statistics/Dashboard";

const routes = [
	{
		path: 'app',
		element: <DashboardLayout />,
		children: [
			{ path: 'dashboard', element: <Navigate to="/app/lpr-events" /> },
			{ path: 'lpr-events', element: <LprEventListView /> },
			{ path: 'parking-events', element: <ParkingEventListView /> },
			{ path: 'parking-zones/new', element: <ParkingZoneFormView /> },
			{ path: 'parking-zones/:id', element: <ParkingZoneFormView /> },
			{ path: 'parking-zones', element: <ParkingZoneListView /> },
			{ path: 'cameras/new', element: <CameraFormView /> },
			{ path: 'cameras/:id', element: <CameraFormView /> },
			{ path: 'cameras', element: <CameraListView /> },
			{ path: 'camera-sets/new', element: <CameraSetFormView /> },
			{ path: 'camera-sets/:id', element: <CameraSetFormView /> },
			{ path: 'camera-sets', element: <CameraSetListView /> },
			{ path: 'audit-log', element: <AuditLogListView /> },
			{ path: 'users', element: <UserListView /> },
			{ path: 'statistics', element: <StatisticsDashboard /> },
			{ path: '*', element: <Navigate to="/404" /> }
		]
	},
	{
		path: '/',
		element: <MainLayout />,
		children: [
			{ path: 'login', element: <LoginView /> },
			{ path: '404', element: <NotFoundView /> },
			{ path: '/', element: <Navigate to="/login" /> },
			{ path: '*', element: <Navigate to="/404" /> }
		]
	}
];

export default routes;